import { render, staticRenderFns } from "./validityPeriod.vue?vue&type=template&id=99a11378&scoped=true&"
import script from "./validityPeriod.vue?vue&type=script&lang=tsx&"
export * from "./validityPeriod.vue?vue&type=script&lang=tsx&"
import style0 from "./validityPeriod.vue?vue&type=style&index=0&id=99a11378&lang=scss&scoped=true&"
import style1 from "./validityPeriod.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99a11378",
  null
  
)

export default component.exports